import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import SignatureScreen from '../../../../../components/SignatureScreen'
import moment from 'moment'
export default {
  props: {
    institutionId: String,
    calibrationId: String,
  },

  components: {
    SignatureScreen,
  },

  async created() {
    this.env = process.env.VUE_APP_BASE_URL
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.currentUser = JSON.parse(localStorage.getItem('user'))
    if (this.calibrationId) {
      await this.getCalibration(this.calibrationId)
    }
  },

  data: () => ({
    institution: {},
    option: 0,
    env: '',
    loading: false,
    signatureConfirmDialog: false,
    signatureErrorDialog: false,
    executingSignatureImage: null,
    validatorSignatureImage: null,
    currentCalibration: null,
    currentUser: {},
    calibrationPatterns: [],
    apiService: new ApiService(),
  }),

  methods: {
    getNextCalibrationDate() {
      return this.currentCalibration && this.currentCalibration.calibrationDate
        ? moment(this.currentCalibration.calibrationDate)
            .add(1, 'y')
            .format('MM/YYYY')
        : ''
    },

    formatMonth(date) {
      return date ? moment(date).format('MM/YYYY') : ''
    },

    async removeValidateCalibration() {
      let valid = false

      if (
        this.institution.userType == 8 ||
        this.institution.userType == 2 ||
        this.currentUser.mainType == 1 ||
        this.currentUser.mainType == 0
      ) {
        valid = true
      }

      if (this.currentUser.id == this.currentCalibration.validatorUserId) {
        valid = true
      }

      if (valid) {
        this.currentCalibration.isValidatorSigned = false
        this.currentCalibration.validatorUserId = null
        this.validatorSignatureImage = null
        await this.apiService
          .post('calibration/edit', this.currentCalibration)
          .then((response) => {
            if (response.statusCode == 200) {
              this.getCalibration(this.calibrationId)
            }
          })
      } else {
        this.$toast.error('Você não tem permissão para remover validações')
      }
    },

    async editCalibration() {
      await this.apiService
        .post('calibration/edit', this.currentCalibration)
        .then((response) => {
          if (response.statusCode == 200) {
            this.getCalibration(this.calibrationId)
          }
        })
    },

    async validateCalibration(data) {
      if (this.option == 0) {
        if (this.currentUser.signatureImage) {
          this.currentCalibration.isValidatorSigned = true
          this.currentCalibration.validatorUserId = this.currentUser.id
          this.currentCalibration.validatorImage = null
          this.signatureConfirmDialog = false
          this.editCalibration()
        } else {
          this.signatureErrorDialog = true
        }
      } else if (this.option == 1) {
        this.currentCalibration.isValidatorSigned = true
        this.currentCalibration.validatorUserId = this.currentUser.id
        this.currentCalibration.validatorImage = data
        this.editCalibration()
        this.signatureConfirmDialog = false
      } else {
        if (
          this.currentCalibration.serviceOrder &&
          this.currentCalibration.serviceOrder &&
          this.currentCalibration.serviceOrder.responsibleName
        ) {
          this.apiService
            .get(
              `byName/${this.currentCalibration.serviceOrder.responsibleName}`
            )
            .then((response) => {
              this.currentCalibration.isValidatorSigned = true
              this.currentCalibration.validatorUserId = response.content.id
              this.currentCalibration.validatorImage = null
              this.signatureConfirmDialog = false
              this.editCalibration()
            })
        } else {
          this.$toast.error(
            'Nenhum responsável encontrado na Ordem de Serviço!'
          )
        }
      }
    },

    async getCalibration(calibrationId) {
      await this.apiService
        .get(`calibration/${this.institutionId}/${calibrationId}`)
        .then((response) => {
          this.currentCalibration = response.content

          if (response.content.isExecutingSigned) {
            this.getUser(response.content.executingUserId, true)
          }

          if (response.content.isValidatorSigned) {
            this.getUser(response.content.validatorUserId, false)
          }

          const templateParameters = response.content.templateParameters

          templateParameters.map((parameter) => {
            const pattern =
              parameter.calibrationPatternTemplateParameter.calibrationPattern

            if (pattern) {
              const findPattern = this.calibrationPatterns.find(
                (x) => x.id == pattern.id
              )
              if (!findPattern) {
                this.calibrationPatterns.push(pattern)
              }
            }
          })
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getUser(userId, isExecuting) {
      await this.apiService
        .get(`user/${userId}`)
        .then((response) => {
          if (isExecuting) {
            if (response.content.signatureImage != null) {
              this.executingSignatureImage = response.content.signatureImage
            }
          } else {
            if (response.content.signatureImage != null) {
              this.validatorSignatureImage = response.content.signatureImage
            }
          }
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    toCertificateDocuments(pattern) {
      sessionStorage.clear()
      sessionStorage.setItem('calibrationPattern', JSON.stringify(pattern))
      window.open(
        `/uploadDocument?certified=${pattern.certifiedNumber}`,
        '_blank'
      )
    },

    async openCertified() {
      await this.apiService
        .post('calibration/generateCertified', this.currentCalibration)
        .then((response) => {
          var pdfResult = 'data:application/pdf;base64,' + response.content.pdf
          const link = document.createElement('a')
          link.href = pdfResult
          link.setAttribute(
            'download',
            `Certificado Calibração Nº ${this.currentCalibration.number}`
          )
          document.body.appendChild(link)
          link.click()
        })
    },

    formatDateTime(date) {
      if (!date) return
      return Utils.dateTime(date)
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    parseDate(date) {
      if (!date) return null

      const dateTimeSplit = date.split(' ')

      const [day, month, year] = dateTimeSplit[0].split('/')
      const time = dateTimeSplit[1]

      if (time) {
        return `${year}-${month.padStart(2, '0')}-${day.padStart(
          2,
          '0'
        )} ${time}:00`
      }

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatInitialDate(dateInitial) {
      const date = new Date(dateInitial),
        day = date.getDate().toString(),
        dayF = day.length == 1 ? '0' + day : day,
        month = (date.getMonth() + 1).toString(),
        monthF = month.length == 1 ? '0' + month : month,
        yearF = date.getFullYear()
      return `${dayF}-${monthF}-${yearF}`
    },
  },
}
